import { useState } from "react";

import emailjs from '@emailjs/browser';

import mississippiLogo from '../Media/Clearloop_Mississippi_AlmostTherePage_01.svg'

const AlmostThere = (props) => {

    const [badEmail, setBadEmail] = useState(false);

    const checkEmail = (e) => {
        const email = document.getElementById("email-input")
        console.log(email.value)

        const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;

        if (emailRegex.test(email.value))
        {
            sendEmail(email.value);
            props.setPage('success');
            setBadEmail(false);
        }else{
            console.log('thats not an email bud!');
            setBadEmail(true);
        }
    }

    const sendEmail = (userEmail) => {
        let formattedString

        switch(props.userType){
            case 'tons':
                formattedString = "offset " + props.userValue.toString() + " metric tons of carbon!"
                break
            case 'dollars':
                formattedString = "spend $" + props.userValue.toString() + " to offset their carbon footprint!"
                break
            case 'watts':
                formattedString = "offset " + props.userValue.toString() + " watts of power with solar!"
                break
            default:
                formattedString = "...sorry there was an error when formatting this data."
                break
            

        }

        const templateParams = {
            userEmail: userEmail,
            formattedString: formattedString,
            selectedType: props.userType,
            selectedValue: props.userValue
        }
        emailjs.send('service_zzfclba', 'template_gxnltug', templateParams, "user_ajx9j7deHClYuJCH4U84N")

        console.log(templateParams)
            

    }

    const d = new Date()

    const currentMonth = d.getMonth() + 1;
    const currentYear = d.getFullYear();
    const meetingURL = `https://calendly.com/hello-clearloop/meeting?month=${currentYear}-${currentMonth}`
    return(
        <div className="col space-around">
            <img src={mississippiLogo}  alt="mississippi logo" id="mississippi-logo"/>
            <h1 className="title-text f-c">Almost There!</h1>
            <p className="f-16 f-c" style={{maxWidth: "500px", margin: "1.5rem auto 2.2rem"}}>Take the next step to commit to your investment in solar energy in Mississippi. Provide us your email and we’ll be in touch.</p>
            <div className="row justify-center">
                <input className="f-gray" type="email" placeholder="yourname@youremail.com" id="email-input" onSubmit={checkEmail}></input>
                <button onClick={checkEmail}>Submit</button>
            </div>
            {badEmail ? <p className="f-yellow f-c">please enter a valid email</p> : null}
            <p className="f-c f-14">Can't wait for our email? <a href={meetingURL} className="f-yellow pointer">Let's meet.</a></p>
        </div>
    )
}

export default AlmostThere;